import React from "react";
import { Button } from "@material-ui/core";
import { Check, GetApp } from "@material-ui/icons";
import fileDownload from "js-file-download";
import { useState } from "react";
import { useIsMounted } from "@ofqual/portal-core/core/hooks";

type RenderFunction = (props: {
  icon: React.ReactNode;
  fileName: string;
  handleClick: () => void;
}) => React.ReactNode;

type DownloadLinkProps = {
  fileName: string;
  getBlob: () => Promise<Blob>;
  children?: RenderFunction;
};

export const DownloadLink: React.FC<DownloadLinkProps> = ({
  fileName,
  getBlob,
  children = defaultRenderer,
}) => {
  const isMountedRef = useIsMounted();

  const [state, setState] = useState<"NOT_DOWNLOADED" | "DOWNLOADING" | "DOWNLOADED">(
    "NOT_DOWNLOADED"
  );

  const onClick = async () => {
    isMountedRef.current && setState("DOWNLOADING");
    const blob = await getBlob();
    fileDownload(blob, fileName);
    isMountedRef.current && setState("DOWNLOADED");
  };

  const icon: React.ReactNode = state === "DOWNLOADED" ? <Check /> : <GetApp />;
  return <>{children({ fileName, icon, handleClick: onClick })}</>;
};

const defaultRenderer: RenderFunction = ({ fileName, handleClick, icon }) => (
  <Button color="primary" onClick={handleClick} title="Click to download">
    {fileName}
    &nbsp;
    {icon}
  </Button>
);
